import React from 'react';

interface AdvancedFilterGroupProps {
  label: string;
  active?: boolean;
  onClear?: () => void;
  children: React.ReactNode;
}

const AdvancedFilterGroup: React.FC<AdvancedFilterGroupProps> = ({ label, active, onClear, children }) => (
  <fieldset className="min-w-0 border-b border-gray-200 pb-5 last:border-0 dark:border-gray-700">
    <legend className="float-left py-3 text-sm font-semibold text-gray-900 dark:text-gray-100">{label}</legend>
    {active && onClear && <button type="button" aria-label={`Clear ${label}`} className="float-right min-h-[44px] px-2 text-sm font-medium text-blue-700 hover:text-blue-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 dark:text-blue-300 dark:hover:text-blue-100" onClick={onClear}>Clear</button>}
    <div className="clear-both" />
    {children}
  </fieldset>
);

export default AdvancedFilterGroup;
